// redux/slices/counterSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { getUserLeaveRequestAPI } from '../Apis/leaveApi';
import { leaveApproveReducer } from "../Reducer/leaveApproveReducer";

const initialStatusCounts = {
    total: 0,
    approved: 0,
    rejected: 0,
    cancelled: 0,
};

const initialState = {
    allLeaves: [],
    pagination: {
        currentPage: 1,
        pageSize: 12,
        totalData: 0,
        totalPages: 1
    },
    statusCounts: initialStatusCounts,
    loading: false,
    isAllLeaveUpdated: false,
    statusFilter: "",
    searchFilter: "",
    monthFilter: "",
    error: null
};

const leaveApproveSlice = createSlice({
    name: "leaveApprove",
    initialState,
    reducers: {
        setLeaveApproveCurrentPage: (state, action) => {
            state.pagination.currentPage = action.payload;
        },
        setLeaveApproveStatusFilter: (state, action) => {
            state.statusFilter = action.payload;
            state.pagination.currentPage = 1;
        },
        setLeaveApproveSearchFilter: (state, action) => {
            state.searchFilter = action.payload;
            state.pagination.currentPage = 1;
        },
        setLeaveApproveMonthFilter: (state, action) => {
            state.monthFilter = action.payload;
            state.pagination.currentPage = 1;
        },
    },
    extraReducers: (builder) => {
        leaveApproveReducer(builder);
    }

});

export const {
    setLeaveApproveCurrentPage,
    setLeaveApproveStatusFilter,
    setLeaveApproveSearchFilter,
    setLeaveApproveMonthFilter,
} = leaveApproveSlice.actions;
export default leaveApproveSlice.reducer;
